import { styled } from '@mui/system';
import { Button } from '@mui/material';

const ClearFiltersButton = styled(Button)({
    backgroundColor: '#0F52BA	',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#1F51FF	', 
    },
  });
export default ClearFiltersButton;